import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItensAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store"


import {IItemOrcamento} from "../../types/IItemOrcamento";

export type reordenarOrcamentoParams = {
    itens: IItemOrcamento[],
}

export async function reordenarOrcamento(params: reordenarOrcamentoParams) {

    const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros?.["ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL"]

    const itens = await microuniversoApi.Orcamento.reordenarOrcamento(
        store.getState().orcamento.IdentificadorOrcamento,
        params.itens,
    )

    // store.dispatch({
    //     itens: itens,
    //     type: MicrouniversoReduxActionType.ORCAMENTO__ATUALIZAR_ITENS
    // } as AtualizarItensPayload)


    store.dispatch(atualizarItensAction({itens, acao: "SOBRESCREVER",corPorAmbiente: store.getState().corPorAmbiente,valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))
}
